import { useForm, FormProvider } from "react-hook-form";
import { Button } from "@moneyforward/mfx_biz_react_components";
import { TermsFormField } from "@/components/molecules";
import React, { useEffect, useState } from "react";
import { useIsSpMode } from "@/hooks";
import { css } from "@emotion/react";

export type ProvisionalRegistrationTermsValues = {
  termOfUse: boolean;
  specialTerm: boolean;
  privacyPolicy: boolean;
  adEmailDelivery: boolean;
};

type Props = {
  onSubmit: (formValues: ProvisionalRegistrationTermsValues) => void;
};

export const ProvisionalRegistrationTerms = (props: Props) => {
  const isSpMode = useIsSpMode();

  const methods = useForm<ProvisionalRegistrationTermsValues>({
    reValidateMode: "onBlur",
  });

  const [agreed, setAgreed] = useState(false);

  const formValues = methods.getValues();
  useEffect(() => {
    setAgreed(
      formValues.termOfUse &&
        formValues.specialTerm &&
        formValues.privacyPolicy &&
        formValues.adEmailDelivery
    );
  }, [formValues]);

  return (
    <>
      <div css={container}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(props.onSubmit)} css={formCSS}>
            <div css={!isSpMode ? box : spModeBox}>
              <div css={listItem}>
                <TermsFormField
                  termOfUse="termOfUse"
                  specialTerm="specialTerm"
                  privacyPolicy="privacyPolicy"
                  adEmailDelivery="adEmailDelivery"
                />
              </div>
            </div>
            <div css={buttonWrapper}>
              <Button
                type="submit"
                disabled={methods.formState.isSubmitting || !agreed}
              >
                登録
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  padding: "0 32px 8px",
  margin: "0 auto",
});

const spModeBox = css({
  padding: "15px 17px",
});

const formCSS = css({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",

  marginTop: "-16px",
  paddingBottom: "16px",
});

const listItem = css({
  marginBottom: "25px",
});

const buttonWrapper = css({
  margin: "8px auto",
});
